import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {find} from 'lodash';

import {IColumn} from '../../../../dialogs/models/create-new-view.interface';

@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterItemComponent implements OnInit {
  @Input() filterControl: AbstractControl;
  @Input() columns: IColumn[];
  @Input() showAdd: boolean = false;

  @Output() update = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() addSameType = new EventEmitter();

  public column: IColumn;
  public get filter() {
    return this.filterControl?.value;
  }

  ngOnInit(): void {
    this.column = find(this.columns, {field: {value: this.filter?.column}});
  }

  addCombined($event: MouseEvent): void {
    $event.stopPropagation();
    this.addSameType.emit(this.filter);
  }
}
